/** Nearest ancestor that scrolls (`overflow` auto or scroll), or null when the page itself scrolls. */
export const findScrollRoot = (element: Element): Element | null => {
  let parent = element.parentElement;
  while (parent && parent !== document.documentElement) {
    const style = getComputedStyle(parent);
    const overflow = style.overflow + style.overflowY;
    if (overflow.includes('auto') || overflow.includes('scroll')) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
};
